import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac8651c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"font-size":"20px","font-weight":"500","color":"#000"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 引振替処理を行う明細行 ")
const _hoisted_3 = { class: "platformOrderNo" }
const _hoisted_4 = { style: {"margin-top":"5px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  type: "text"
}
const _hoisted_7 = { class: "flex-ter-cen" }
const _hoisted_8 = { style: {"width":"120px","text-align":"left"} }
const _hoisted_9 = {
  key: 0,
  class: "show-two-line"
}
const _hoisted_10 = { class: "show-two-line" }
const _hoisted_11 = { class: "product-sku-word" }
const _hoisted_12 = { class: "flex just-center" }
const _hoisted_13 = { class: "show-one-line" }
const _hoisted_14 = {
  key: 1,
  class: "show-one-line"
}
const _hoisted_15 = {
  style: {"min-height":"84px"},
  class: "flex-col-center"
}
const _hoisted_16 = { class: "card" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "引当振替処理", -1))
const _hoisted_18 = { class: "card_body" }
const _hoisted_19 = { class: "search flex-ter" }
const _hoisted_20 = { class: "choose_container" }
const _hoisted_21 = { class: "flex-bwn-ter" }
const _hoisted_22 = { class: "flex-bwn-ter" }
const _hoisted_23 = { class: "platformOrderItemId" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status" }, "処理中", -1))
const _hoisted_25 = { class: "flex-bwn-ter" }
const _hoisted_26 = { class: "customerName" }
const _hoisted_27 = { class: "num" }
const _hoisted_28 = { class: "drawer-footer" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 実行 ")

import { ref, onUnmounted, onMounted, nextTick, computed, watch } from 'vue'
import STable from '@/components/Table/index.vue'
// import { shopInfoDrawerColumns, groupTableConfig, combinationColumns } from './SalesPerspectiveData'
import { t } from '@/plugins/i18n'
import { request } from '@/config/request/interceptors'
import { QueryBindGoodsRespDTO } from '@/service/apis'
import AppLink from '@/components/common/AppLink.vue'
import CopyButton from '@/components/common/CopyButton.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { isJA, useRtfix } from '@/store'
import { dayjs, ElMessage, ElMessageBox, ElStep } from 'element-plus'
import { showCurrentUnit, showPriceAndUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'
import DocumentaryRecord from '@/views/usercenter/Order/components/DocumentaryRecord.vue'
import { combinationStatusDict } from '../../data'
import { QuerySwapStockOrderItemDTO, QuerySwapStockOrderRespDTO } from '@/service/order'
interface ExtQuerySwapStockOrderRespDTO extends QuerySwapStockOrderRespDTO {
  cancelProgress?: boolean
}

enum Enum_country {
  'CN' = t('中国'),
  'KR' = t('韩国'),
  'JP' = t('日本'),
}


export default /*#__PURE__*/_defineComponent({
  emits: ['success', 'error'],
  setup(__props, { expose, emit: emits }) {



const visiable = ref(false)
// 查看订单行数据
const tableData = ref<any[]>([])
const rowData = ref<any>({})
const swapStockOrderList = ref<ExtQuerySwapStockOrderRespDTO[]>([])
const checkedList = ref<any[]>([])
const filterSwapStockOrderList = ref<ExtQuerySwapStockOrderRespDTO[]>([])

const form = ref({
  sortType: '1',
  keywords: ''
})

watch(() => checkedList.value, () => {
  const checkedSwap = swapStockOrderList.value.filter(item => checkedList.value.includes(item.platformOrderNo))
  if (checkedSwap?.reduce((pre, cur) => pre + (cur.totalQuantity || 0), 0) >= needQuantity.value) {
    swapStockOrderList.value.forEach(i => {
      if (checkedList.value.includes(i.platformOrderNo)) {
        i.cancelProgress = false
      } else {
        i.cancelProgress = true
      }
    })
  } else {
    swapStockOrderList.value.forEach(i => {
      i.cancelProgress = false
    })
  }
})

const reset = async () => {
  await queryBindGoods()
  form.value = {
    sortType: '1',
    keywords: ''
  }
  query()
}

const query = async () => {
  await queryBindGoods()
  filterSwapStockOrderList.value = (swapStockOrderList.value?.filter(item => {
    const matchKeyword = form.value.keywords ? (item?.platformOrderNo === form.value.keywords || item.customerOrderNo === form.value.keywords || item.receiveName?.includes(form.value.keywords)) : true
    return matchKeyword
  }) ?? [])
  console.log(filterSwapStockOrderList.value, 'filterSwapStockOrderList')

  if (form.value.sortType) {
    filterSwapStockOrderList.value = filterSwapStockOrderList.value.sort((a, b) => {
      if (form.value.sortType === '1') {
        return dayjs(a.createTime).isBefore(dayjs(b.createTime)) ? -1 : 1
      } else {
        return dayjs(a.createTime).isBefore(dayjs(b.createTime)) ? 1 : -1
      }
    })
  }
}

const productTableConfig = {
  showSelection: false,
  setHeight: true,
  showExpand: true,
  rowKey: 'thirdSkuCode',
  expandConfigId: 'combinationProductItemList',
  showHandler: false
}

const columns: any = [
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats',
    width: 120
  }, {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo'
  }, {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    width: 160,
    align: 'center',
    slotName: 'productPropertiesName'
  }, {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center'
  }, {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku',
    width: 280
  },
  {
    label: `${t('商品单价')}`,
    prop: 'actualProductSellPrice',
    slotName: 'actualProductSellPrice',
    align: 'center'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center',
    width: 80
  }
]

// 国家枚举
onUnmounted(() => {
  window.removeEventListener('resize', changeTableWidth)
})

const changeTableWidth = () => {
  // 计算展开table的宽度
  tableWidth.value = document.querySelector('.shop-info-drawer')?.clientWidth || 0
}

const tableWidth = ref(0)
const showBtn = ref(false)
onMounted(async () => {
  changeTableWidth()
  window.addEventListener('resize', changeTableWidth)
})

const queryBindGoods = async (isShow?: boolean) => {
  const res = await request.order.customer.platformOrderItemQuerySwapStockOrderList({
    platformOrderItemId: rowData.value.platformOrderItemId
  })
  if (isShow) {
    if (res.data?.length) {
      visiable.value = true
    } else {
      ElMessage.error('引当振替可能な商品がありません。')
    }
  }
  filterSwapStockOrderList.value = swapStockOrderList.value = (res.data ?? []).map(item => {
    item.cancelProgress = false
    return item
  })
  checkedList.value = []
}

const needQuantity = computed(() => {
  return rowData.value?.orderItemStatusList.reduce((pre, cur) => {
    return pre + ([14, 15].includes(cur.orderItemStatus) ? cur.commodityQuantity : 0)
  }, 0)
})

function filterItemsByQuantitySum(
  items: QuerySwapStockOrderItemDTO[],
  targetValue: number
): {
  criticalIndex: number; // 临界索引（-1表示总和不足）
  total: number; // 最终累加和
  filteredItems: QuerySwapStockOrderItemDTO[]; // 过滤后的数组（第一项到临界项）
} {
  let total = 0
  let criticalIndex = -1
  const filteredItems: QuerySwapStockOrderItemDTO[] = []

  for (let index = 0; index < items.length; index++) {
    const item = items[index]
    // 安全处理：确保quantity是有效数字，非数字按0处理
    const quantity = typeof item.quantity === 'number' ? item.quantity : 0

    total += quantity
    // 将当前项加入过滤数组
    filteredItems.push(item)

    // 达到目标值则记录索引并终止循环
    if (total >= targetValue) {
      criticalIndex = index
      break
    }
  }

  // // 如果总和不足目标值，清空过滤数组（也可保留全部，根据你的需求调整）
  // if (criticalIndex === -1) {
  //   filteredItems = [] // 若需要保留全部元素，注释这行即可
  // }

  return { criticalIndex, total, filteredItems }
}

// 调整最后一项
function adjustLastItemQuantity(filteredItems: QuerySwapStockOrderItemDTO[], needQuantityValue: number) {
  if (filteredItems.length === 0) return

  const sumWithoutLast = filteredItems.slice(0, -1).reduce((sum, item) => sum + (item.quantity ?? 0), 0)
  const lastItem = filteredItems[filteredItems.length - 1]

  lastItem.quantity = needQuantityValue - sumWithoutLast

  // 确保不为负数
  // if (lastItem.quantity < 0) {
  //   lastItem.quantity = 0
  // }
}

const loading = ref(false)

const handleSure = async () => {
  try {
    if (checkedList.value.length > 0) {
      loading.value = true
      const list = filterSwapStockOrderList.value.filter(i => checkedList.value.includes(i.platformOrderNo)).reduce((pre, next) => {
        return pre.concat(next.details ?? [])
      }, [])

      const { filteredItems } = filterItemsByQuantitySum(list, needQuantity.value)
      const total = filteredItems.reduce((pre, cur) => pre + (cur.quantity ?? 0), 0)
      if (total > needQuantity.value) {
        adjustLastItemQuantity(filteredItems, needQuantity.value)
      }
      const res = await request.order.customer.platformOrderItemSwapStock({
        platformOrderItemId: rowData.value.platformOrderItemId,
        quantity: total > needQuantity.value ? needQuantity.value : total,
        details: filteredItems
      })
      loading.value = false
      if (res.code == '0') {
        ElMessage.success('引当振替処理を行いました')
        emits('success', rowData.value)
        visiable.value = false
      } else {
        visiable.value = false
        emits('error', rowData.value)
      }
    } else {
      ElMessage.error(t('请选择订单'))
    }
  } catch (error) {
    console.log(error)
  } finally {
    loading.value = false
  }
}

expose({
  show: async (row: any) => {
    rowData.value = row
    tableData.value = [row]
    queryBindGoods(true)

  }
})

// // 组合商品展开
// const handleExpandRow = (val: any, flag: boolean) => {
//   if (flag) {
//     val.loading = true
//     getCombinaProductDetailApi(val.productSku).then((res: any) => {
//       val.combinationProductItemList = res.data?.combinationProductItemList || []
//     }).finally(() => {
//       val.loading = false
//     })
//   }
// }


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElForm = _resolveComponent("ElForm")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_ElDrawer = _resolveComponent("ElDrawer")!

  return (_openBlock(), _createBlock(_component_ElDrawer, {
    "custom-class": "replaceGoods_drawer",
    modelValue: visiable.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visiable).value = $event)),
    direction: "btt",
    size: "80%"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(rowData.value?.platformOrderNo), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_el_button, {
          loading: loading.value,
          disabled: loading.value || !checkedList.value?.length,
          color: "#000",
          size: "large",
          type: "primary",
          onClick: handleSure
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['productRef'] = _value
          },
          tableData: tableData.value,
          tableConfig: productTableConfig,
          showPagination: false,
          columns: columns,
          showAllExpand: false
        }, {
          shoppingStats: _withCtx(({ row }) => [
            (row.virtualFlag)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " - "))
              : (row.productType === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(combinationStatusDict)[row.combinationStatus]), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    row
                      ? (_openBlock(), _createBlock(DocumentaryRecord, {
                          key: 0,
                          row: row,
                          cancelJump: true,
                          showExpress: true,
                          isReplenish: row.smartReplenishFlag
                        }, null, 8, ["row", "isReplenish"]))
                      : _createCommentVNode("", true)
                  ], 64))
          ]),
          shoppingInfo: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createVNode(ShoppingPreview, {
                  image: row.productSkuImg || row.productMainImg || ''
                }, null, 8, ["image"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (
                (!row?.productType || row?.productType === 1) &&
                row?.productCode
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_el_tooltip, { effect: "light" }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(row?.productTitle), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(AppLink, {
                            class: "show-two-line",
                            style: {"height":"45px"},
                            to: _unref(useRtfix)('goods', { params: { id: row?.productCode } }),
                            target: "_blank",
                            tag: "a"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row?.productTitle), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 1,
                      effect: "light"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(row?.productTitle), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(row?.productTitle), 1)
                      ]),
                      _: 2
                    }, 1024))
              ])
            ])
          ]),
          productSku: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_tooltip, { effect: "light" }, {
                content: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(row.productSku), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    (row.productCode && row.productType !== 2)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          target: "_blank",
                          tag: "a",
                          to: _unref(useRtfix)('goods', {
                  params: { id: row.productCode ?? 'null' },
                })
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(row.productSku), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(row.productSku), 1)),
                    _createVNode(CopyButton, {
                      text: row.productSku
                    }, null, 8, ["text"])
                  ])
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          productPropertiesName: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
              }), 128))
            ])
          ]),
          actualProductSellPrice: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualProductSellPrice, _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1)
          ]),
          _: 1
        }, 8, ["tableData"]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_ElForm, {
                inline: "",
                modelValue: form.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElFormItem, {
                    label: "振替元の受注伝票",
                    prop: "keywords"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        style: {"width":"380px"},
                        placeholder: "THE CKB注文番号、お客様注文番号、受取人で検索して",
                        modelValue: form.value.keywords,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.keywords) = $event)),
                        modelModifiers: { trim: true }
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ElFormItem, {
                    label: _unref(t)('创建时间'),
                    prop: "sortType",
                    default: "1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: form.value.sortType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.sortType) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "作成日時（昇順）",
                            value: "1"
                          }),
                          _createVNode(_component_el_option, {
                            label: "作成日時（降順）",
                            value: "2"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_ElFormItem, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: query
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('查询')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, { onClick: reset }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox_group, {
                modelValue: checkedList.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkedList).value = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterSwapStockOrderList.value, (swap) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "choose_box",
                        key: swap.platformOrderItemId
                      }, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_el_checkbox, {
                              disabled: swap.cancelProgress,
                              key: swap.platformOrderNo,
                              label: swap.platformOrderNo,
                              value: swap.platformOrderNo
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "label", "value"]),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(swap.platformOrderNo), 1)
                          ]),
                          _hoisted_24
                        ]),
                        _createVNode(_component_el_divider, { style: {"margin":"8px 0"} }),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(swap.receiveName || ''), 1),
                          _createElementVNode("div", _hoisted_27, _toDisplayString(swap.totalQuantity) + "個が引済み", 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})